import React, { createRef, useEffect, useMemo, useState } from "react";
import PrevArrow from "../../LearningPaths/PrevArrow";
import NextArrow from "../../LearningPaths/NextArrow";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { SessionKeys } from "../../../utils/AppUtils";
import { useDispatch, useSelector } from "react-redux";
import Accordion from 'react-bootstrap/Accordion';

import {
  getCrsReportRea,
  getCrsReportReaClear,
  getCrsReportOffices,
  getCrsReportStats,
  getCrsReportStatsClear,
  getCrsReportTrend,
  getCrsReportTrendClear
} from "../../../redux/reports/actions";
import _ from "lodash";

import Loader from "../../Loader/Loader";

import {
  getAnyTotalReportClear,
  getProfileCompletionReport,
  getProfileCompletionReportClear,
} from "../../../redux/reports/actions";

import { useLocation, useNavigate } from "react-router-dom";

import { Spinner } from "react-bootstrap";

import CompletionTrendGraphNew from "../ReportsComponents/CompletionTrendGraphNew";
import DonutChart from "../../Layouts/Graphs/DonutChart";
const AgentReportSection = (props) => {

  const {
    selectedTeamMatesList,
    selectedCourseList,
    selectedManagerCoachList,
    selectedProviderList,
    isMobile
  } = props;

  const dispatch = useDispatch();
  const history = useNavigate();
  const location = useLocation();
  const userDetailRes = useSelector(state => state.user.userBroker)
  const userDetailIframe = useSelector(state => state.user.userDetailIframe)
  const overAllSummaryCrsRes = useSelector(
    (state) => state.report.overallSummaryCrsData
  );
  const [overSummaryCrsData, setOverSummaryCrsData] = useState([]);
  const overAllDataRes = useSelector((state) => state.report.overallData);
  const overAllSummaryGraphRes = useSelector(
    (state) => state.report.overallSummaryCrsGraph
  );
  const [reaList, setReaList] = useState([])
  const [overCrsGraphData, setOverCrsGraphData] = useState([]);
  const [crsCompltTrendData, setCrsCompltTrendData] = useState([]);
  const [overAllData, setOverAllData] = useState([]);
  const [overAllOfficesData, setOverAllOfficesData] = useState([]);
  const [overAllManagersData, setOverAllManagersData] = useState([]);
  const [overAllLearningPoints, setOverAllLearningPoints] = useState([]);
  const [overAllLearningHours, setOverAllLearningHours] = useState([]);
  const [OverAllStatsData, setOverAllStatsData] = useState([]);
  const [isView, setIsView] = useState("table");
  const [type, setType] = useState("pie");
  const [canShow, setCanShow] = useState(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [limitStatus, setLimitStatus] = useState("")
  const [loadSpin, setLoadSpin] = useState(true)
  const [totalRea, setTotalRea] = useState([])
  const [isLoading, setIsLoading] = useState(true);
  const [filterYearData, setFilterYearData] = useState([])
  const d = new Date();
  let year = d.getFullYear();
  const [trendYear, setTrendYear] = useState(year)
  const [imgLoader, setImgLoader] = useState(true);
  const [crsCompltTrendValues, setCrsCompltTrendValues] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [statusFilterData] = useState([
    "Completed",
    "Inprogress",
    "Yet to start",
    "OverDue",
  ]);
  const crsTableRes = useSelector((state) => state.report?.lpTable);
  const crsReaRes = useSelector((state) => state.report?.crsReportRea);
  const crsManagersRes = useSelector((state) => state.report?.crsReportManagers);
  const crsOfficesRes = useSelector((state) => state.report?.crsReportOffices);
  const crsTrendRes = useSelector((state) => state.report?.crsReportTrend);
  const crsStatsRes = useSelector((state) => state.report?.crsReportStats);
  const [profileReports, setProfileReports] = useState(null);
  const [realEstateAgent, setRealEstateAgent] = useState([]);
  const profileReportRes = useSelector((state) => state.report.profileReport);
  const anyTotalReportRes = useSelector(
    (state) => state.report?.anyTotalReport
  );
  const crsCompletionTrendRes = useSelector(
    (state) => state.report.crsCompletionTrend
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [limitData, setLimitData] = useState();
  const [totalRecord, setTotalRecord] = useState(0);
  const [legends, setLegends] = useState([]);
  const [series, setSeries] = useState([]);
  let PageSize = 20;
  const [counter, setCounter] = useState(1);
  const FILTER_BY = [
    { id: 0, value: "Select" },
    { id: 1, value: "Learning Points" },
    { id: 2, value: "Progress" },
    { id: 3, value: "Learning Hours" },
  ];
  const [filterBy, setFilterBy] = useState(FILTER_BY[0].value);
  const [actualCoursesList, setActualCoursesList] = useState([]);
  const [coursesList, setCoursesList] = useState([]);
  const [increment, setIncrement] = useState(1);
  const rea_ids = []
  const office_ids = []
  const courseList = []
  const providerList = []
  const [selectedOfficeList] = useState(
    location?.state?.selectedOfficeList
  );
  const [selectedRea] = useState(
    location?.state?.selectedTeamMatesList
  );
  const [selectedCrsList] = useState(
    location?.state?.selectedCourseList)
  const [provrlist] = useState(location?.state?.selectedProviderList)

  // new designchanges 1-May-23
  const [isExpand, setIsExpand] = useState(false);

  function setCount(counter, setCounter) {
    return setCounter(counter + 1);
  }

  useEffect(() => {
    // console.log('userDetailRes: ', userDetailRes)
    if (isMobile) {
      if (!_.isEmpty(userDetailIframe?.payload?.payload)) {
        setUserDetails(userDetailIframe?.payload?.payload)
      }
    } else {
      if (!_.isEmpty(userDetailRes?.payload?.payload)) {
        setUserDetails(userDetailRes?.payload?.payload)
      }
    }
  }, [userDetailRes, userDetailIframe, isMobile])

  useEffect(() => {
    dispatch(
      getProfileCompletionReport({
        module: "getCourseProgressReport",
        postData: {
          token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          limit: counter,
          rea_ids: rea_ids,
          entity_id: courseList,
          office_ids: office_ids,
          provider_ids: providerList,
          compliance: 0
        },
      })
    );
    // setFilterBy(FILTER_BY[0].value);
  }, [dispatch, counter]);
  useEffect(() => {
    if (!_.isEmpty(profileReportRes)) {
      let legends = [];
      let series = [];
      if (profileReportRes?.status === "success") {
        setIsLoading(false);
        const reportData = profileReportRes?.payload?.payload;
        setProfileReports(reportData);
        if (statusFilterData.includes("Completed")) {
          let completedCount = reportData?.filter((data) => data.profile_status === "Completed").length;
          series.push(
            reportData?.filter((data) => data.profile_status === "Completed").length
          );
          legends.push(`Completed (${completedCount})`);
        }
        if (statusFilterData.includes("Inprogress")) {
          let inprogressCount = reportData?.filter((data) => data.profile_status === "Inprogress").length
          series.push(
            reportData?.filter((data) => data.profile_status === "Inprogress").length
          );
          legends.push(`In Progress (${inprogressCount})`);
        }
        if (statusFilterData.includes("OverDue")) {
          let overdueCount = reportData?.filter((data) => data.profile_status === "OverDue").length
          series.push(
            reportData?.filter((data) => data.profile_status === "OverDue").length
          );
          legends.push(`Overdue (${overdueCount})`);
        }
        if (statusFilterData.includes("Yet to start")) {
          let notStartedCount = reportData?.filter((data) => data.profile_status === "Yet to start").length
          series.push(
            reportData?.filter((data) => data.profile_status === "Yet to start").length
          );
          legends.push(`Yet to start (${notStartedCount})`);
        }
        setLegends(legends);
        setSeries(series);
        setCurrentPage(1);
      } else {
        setProfileReports([]);
        setCanShow(false);
        setIsLoading(false);
      }
      dispatch(getProfileCompletionReportClear());
    }
  }, [profileReportRes]);

  useEffect(() => {
    if (!_.isEmpty(anyTotalReportRes)) {
      if (anyTotalReportRes.status === "success") {
        setTotalRecord(anyTotalReportRes.payload.payload.length);
      }
      return () => {
        dispatch(getAnyTotalReportClear());
      };
    }
  }, [anyTotalReportRes]);

  const sliderRef = createRef();
  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    dots: true,
    arrows: true,
    autoplaySpeed: 2000,
    infinite: false,
    centerMode: false,
    swipe: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const percentage = 66;



  useEffect(() => {
    dispatch(getCrsReportRea({
      module: 'getCourseReportRea',
      postData: {
        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        rea_ids: rea_ids,
        limit: counter,
        office_ids: office_ids,
        entity_id: courseList,
        provider_ids: providerList,
        compliance: 0
      }
    }))

  }, [dispatch, counter])

  useEffect(() => {
    dispatch(getCrsReportOffices({
      module: 'getCourseReportOffices',
      postData: {
        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        office_ids: office_ids,
        rea_ids: rea_ids,
        limit: counter,
        compliance: 0,
        provider_ids: providerList,
        entity_id: courseList,
      }
    }))
  }, [dispatch])
  useEffect(() => {
    dispatch(getCrsReportTrend({
      module: 'getCourseReportTrend',
      postData: {
        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        office_ids: office_ids,
        rea_ids: rea_ids,
        entity_id: courseList,
        compliance: 0,
        provider_ids: providerList,
        year: _.toNumber(trendYear)
      }
    }))
  }, [dispatch, trendYear])

  useEffect(() => {
    dispatch(getCrsReportStats({
      module: 'getCourseReportStats',
      postData: {
        token: isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        office_ids: office_ids,
        rea_ids: rea_ids,
        entity_id: courseList,
        provider_ids: providerList,
        compliance: 0
      }
    }))
  }, [dispatch])
  useEffect(() => {
    dispatch(
      getCrsReportStatsClear());
  }, [dispatch])

  useEffect(() => {
    setCounter(1)
    setRealEstateAgent([])
    return (() => {
      dispatch(getCrsReportReaClear())
    })
  }, [])
  //LP Rea
  useEffect(() => {
    if (!_.isEmpty(crsReaRes)) {
      setLoadSpin(false)
      if (crsReaRes?.status === "success") {

        let allData = [];
        allData = sortByAlphabetical(crsReaRes?.payload?.payload?.real_estate_agents);
        let realEstateAgents = crsReaRes?.payload?.payload?.real_estate_agents;
        setTotalRea(crsReaRes?.payload?.payload)
        let temparr = _.cloneDeep(realEstateAgent)
        if (counter === 1) {
          temparr = []
        }
        setReaList([...temparr, ...allData])
        setLimitStatus(crsReaRes?.payload?.payload?.real_estate_agents)
        setRealEstateAgent([...temparr, ...allData]);
        setActualCoursesList([...temparr, ...allData]);
        dispatch(getCrsReportReaClear())
      }
    }
  }, [crsReaRes])


  useEffect(() => {
    // setCrsCompltTrendValues([])    
    return (() => {
      dispatch(getCrsReportTrendClear())
    })
  }, [])
  //Course Completion trend
  useEffect(() => {
    if (!_.isEmpty(crsTrendRes)) {
      if (crsTrendRes?.status === "success") {
        setImgLoader(false);
        let allData = []
        allData = crsTrendRes?.payload?.payload?.completion_trend;
        setCrsCompltTrendValues(Object.values(allData));
        setFilterYearData(crsTrendRes?.payload?.payload?.year)
        dispatch(getCrsReportTrendClear())
      }
    }
  }, [crsTrendRes])

  //LP Stats
  useEffect(() => {
    if (!_.isEmpty(crsStatsRes)) {
      if (crsStatsRes?.status === "success") {
        setIsLoaded(false);
        let allData = crsStatsRes?.payload?.payload?.stats;
        setOverAllLearningPoints(allData)
      }
      getCrsReportStatsClear()
    }
  }, [crsStatsRes])

  const currentTableData = useMemo(() => {
    if (profileReports !== null) {
      const firstPageIndex = (currentPage - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      setCanShow(true);
      return profileReports?.slice(firstPageIndex, lastPageIndex);
    }
  }, [currentPage, profileReports]);
  // let min = Math.ceil(overAllLearningPoints?.learning_mins * 60);
  // filtration
  const sortByAlphabetical = (list) => {
    return list?.sort((a, b) => b.learning_points - a.learning_points);
  };
  const sortByProgress = (list) => {
    return list?.sort(
      (a, b) =>
        _.toNumber(b.learning_percentage) - _.toNumber(a.learning_percentage)
    );
  };
  const sortByLearningHrs = (list) => {
    return list?.sort(
      (a, b) => _.toNumber(b.learning_hrs) - _.toNumber(a.learning_hrs)
    );
  };
  //REA SECTION
  const onClickFilterBy = (e) => {
    setFilterBy(e.target.value);
    if (e.target.value === "Learning Points") {
      const sortedList = sortByAlphabetical(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else if (e.target.value === "Progress") {
      const sortedList = sortByProgress(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else if (e.target.value === "Learning Hours") {
      const sortedList = sortByLearningHrs(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else {
      setRealEstateAgent(reaList)
    }
  };

  useEffect(() => {
    if (counter > 1)
      sortAfterLoadMore();
  }, [actualCoursesList])

  const sortAfterLoadMore = () => {
    if (filterBy === "Learning Points") {
      const sortedList = sortByAlphabetical(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else if (filterBy === "Progress") {
      const sortedList = sortByProgress(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else if (filterBy === "Learning Hours") {
      const sortedList = sortByLearningHrs(actualCoursesList);
      setRealEstateAgent(sortedList);
    } else {
      setRealEstateAgent(reaList)
    }
  };

  return (
    <>
      <Loader start={isLoading} />
      <section className="reports-header mt-2rem">
        <div className="container-pwc">
          <div className="row">
            <div className="col-md-12">
              <div className="reports-head-main">
                Reports
              </div>
            </div>
            <div className="col-md-12">
              <div className="agent-user-detailbox">
                <div className="agent-img">
                  <img src="/images/richmond.png" width="96" height="96" className="img-fluid" alt="" />
                </div>
                <div className="agent-detsils">
                  <div class="agent-name-rsp">
                      Richmond Hill
                  </div>
                  <div className="agent-desg">
                    Ontario, Canada
                  </div>
                  {false && <div className="agent-location">
                    Richmond Hill
                  </div>}
                  <div className="applied-filter-agents">
                    37 Agents, 3 Managers
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-flex justify-content-between dropbox-section">
              <div className="reports-head-main-filter">
              <div className="report-page-title">Compliance Report</div>
                {/* <Dropdown>
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    Compliance Report
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
                    <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">Something else</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown> */}

                
                {<div className="subtextfilter">An overview of learners adhering to all the regulatory requirements</div>}
                {!isExpand && <div className="applied-filter-box mb-4 cursor-pointer"
                  onClick={() => {
                    setIsExpand(true)
                  }}>
                  <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    width="18px" height="18px" viewBox="0 0 971.986 971.986">
                    <g>
                      <path d="M370.216,459.3c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3
                                c16.5-19.8,25.6-29.601,25.6-49.2V500c0-15,5.7-29.5,15.8-40.601L955.615,75.5c26.5-28.8,6.101-75.5-33.1-75.5h-873
                                c-39.2,0-59.7,46.6-33.1,75.5L370.216,459.3z"/>
                    </g>
                  </svg>
                  Filters</div>}
              </div>
              <div className="report-download">
              <svg id="Component_115_14" data-name="Component 115 â 14"
                xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="30"
                  height="30"
                  viewBox="0 0 30 30">
                    <defs>
                      <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                        <stop offset="0" stop-color="#415385"/>
                        <stop offset="1" stop-color="#415385"/>
                      </linearGradient>
                    </defs>
                    <circle id="Ellipse_57" data-name="Ellipse 57" cx="15" cy="15" r="15" fill="url(#linear-gradient)"/>
                    <circle id="Ellipse_179" data-name="Ellipse 179" cx="13" cy="13" r="13" transform="translate(2 2)" fill="#fff"/>
                    <path id="database-export" d="M9.62,3C6.515,3,4,4.257,4,5.81S6.515,8.62,9.62,8.62c.351,0,.7-.021,1.054-.056v-1H12.7l-.7-.7,2.466-2.459A7.748,7.748,0,0,0,9.62,3m4.861,2.866-1,1L15.24,8.62H11.728v1.405H15.24l-1.756,1.756,1,1,3.456-3.456M4,7.215V9.323c0,1.553,2.515,2.81,5.62,2.81a10.5,10.5,0,0,0,2.283-.26l.794-.794H10.674V9.969c-.351.035-.7.056-1.054.056C6.515,10.025,4,8.768,4,7.215m0,3.513v2.108c0,1.553,2.515,2.81,5.62,2.81a7.748,7.748,0,0,0,4.847-1.405l-1.335-1.335a9.473,9.473,0,0,1-3.513.632C6.515,13.538,4,12.28,4,10.728Z" transform="translate(4.6 5.677)" fill="#415385"/>
                </svg>
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  id="Find"
                  width="45"
                  height="45"
                  viewBox="0 0 30 30"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      y1="0.5"
                      x2="1"
                      y2="0.5"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stop-color="#415385" />
                      <stop offset="1" stop-color="#415385" />
                    </linearGradient>
                  </defs>
                  <circle
                    id="Ellipse_57"
                    data-name="Ellipse 57"
                    cx="15"
                    cy="15"
                    r="15"
                    fill="url(#linear-gradient)"
                  />
                  <circle
                    id="Ellipse_179"
                    data-name="Ellipse 179"
                    cx="13"
                    cy="13"
                    r="13"
                    transform="translate(2 2)"
                    fill="#fff"
                  />
                  <path
                    id="file-chart"
                    d="M10.365,6.951h3.89l-3.89-3.89v3.89M5.415,2h5.658l4.244,4.244v8.487A1.415,1.415,0,0,1,13.9,16.146H5.415A1.414,1.414,0,0,1,4,14.731V3.415A1.41,1.41,0,0,1,5.415,2m.707,12.731H7.536V10.487H6.122v4.244m2.829,0h1.415V9.073H8.951v5.658m2.829,0h1.415V11.9H11.78Z"
                    transform="translate(5.342 5.927)"
                    fill="#415385"
                  />
                </svg> */}
              </div>
            </div>
            <div className="col-md-12">
              {isExpand && <section className="filter-box-reports">
                <div className="filter-box-header d-flex justify-content-between">
                  <div className="filter-head-left cursor-pointer"
                    onClick={() => { setIsExpand(false) }}>
                    <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                      width="18px" height="18px" viewBox="0 0 971.986 971.986">
                      <g>
                        <path d="M370.216,459.3c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3
                                c16.5-19.8,25.6-29.601,25.6-49.2V500c0-15,5.7-29.5,15.8-40.601L955.615,75.5c26.5-28.8,6.101-75.5-33.1-75.5h-873
                                c-39.2,0-59.7,46.6-33.1,75.5L370.216,459.3z"/>
                      </g>
                    </svg>
                    Filters
                  </div>
                  <div className="filter-apply-right">
                    <div className="expand-filter" data-bs-target=".multi-collapse" aria-expanded="false" aria-controls="multiCollapseExample1 multiCollapseExample2"
                    >
                      Expand All
                    </div>
                    <div className="expand-filter">
                      Collapse All
                    </div>
                  </div>
                </div>
                <div className="filter-options-report">

                <Accordion>
                  <Accordion.Item eventKey="0" className="multi-collapse" id="multiCollapseExample1">
                    <Accordion.Header>Reporting Period</Accordion.Header>
                    <Accordion.Body>
                      Filter Data
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="1" className="multi-collapse" id="multiCollapseExample2">
                    <Accordion.Header>Provider</Accordion.Header>
                    <Accordion.Body>
                   Filter Data
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>Offices</Accordion.Header>
                    <Accordion.Body>
                    Filter Data
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="3">
                    <Accordion.Header>Reporting to</Accordion.Header>
                    <Accordion.Body>
                    Filter Data
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>Learning Content Type</Accordion.Header>
                    <Accordion.Body>
                    Filter Data
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>Roles</Accordion.Header>
                    <Accordion.Body>
                    Filter Data
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="6">
                    <Accordion.Header>Learning Content</Accordion.Header>
                    <Accordion.Body>
                    Filter Data
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="7">
                    <Accordion.Header>Agent</Accordion.Header>
                    <Accordion.Body>
                    Filter Data
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="8">
                    <Accordion.Header>Status</Accordion.Header>
                    <Accordion.Body>
                    Filter Data
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                </div>
              </section>}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="reports-chart graph-box-learnong shadow-box-report">
                <div className="chart-heading-report">
                  Summary
                </div>
                <div className="row">
                  <div className="col-md-5 col-xl-4">
                    <div className="graph-box-learnong">
                      <div
                        className="circularProgress"
                        style={{
                          width: 150,
                          height: 150,
                          position: "relative",
                        }}
                      >
                        <CircularProgressbar
                          value={25}
                          strokeWidth={25}
                          styles={buildStyles({
                            pathColor: "#415385", //FF9700=yellow
                            trailColor: "#EBEBEB",
                          })
                          }
                        />
                        <div className="circular-progess-data"
                          style={{
                            position: "absolute",
                            top: "0",
                            width: "150px",
                            bottom: "0",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                        >
                          {true ? (
                            <>
                              <strong
                                style={{ color: "black" }}
                              >{`25%`}</strong>

                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="complints-sub-text">
                        Overall Compliance %
                      </div>
                    </div>

                  </div>
                  <div className="col-md-7 col-xl-8">
                    <div className="graph-box-learnong">
                      <div className="proglefttext">Compliance Courses</div>
                      <div className="d-flex gap-5 justify-content-center">
                        <div className="count-col">
                          <div className="coluns-report-rsp">
                            <strong>10/</strong>40
                          </div>
                          <div className="complints-sub-text">
                            Agents Compliant
                          </div>
                        </div>
                        <div className="count-col">
                          <div className="coluns-report-rsp-percent">
                            +5<small>%</small>
                          </div>
                          <div className="complints-sub-text">
                            From Last Week
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="reports-chart graph-box-learnong shadow-box-report">

                <div className="row">
                  <div className="col-md-5 col-xl-4">
                    <div className="graph-box-learnong grah-center flex-column justify-content-start">
                      <div className="proglefttext">Completion Status</div>
                      <DonutChart />
                      {/* <img src="/images/donut.png" alt="" /> */}
                      {/* <div className="complints-sub-text">
                                        Overall Compliance %
                                      </div> */}
                    </div>

                  </div>
                  <div className="col-md-7 col-xl-8">
                    <div className="graph-box-learnong">
                      <div className="proglefttext">Completion Trend</div>
                      <div className="completion-tranding-graph">
                        <CompletionTrendGraphNew
                          crsCompltTrendData={crsCompltTrendValues}
                          completionTrendLabel={"Courses Completion"}
                          crsCompltTrend={filterYearData}
                          setTrendYear={setTrendYear}
                          trendYear={trendYear}
                        />
                        <p className="text-center graphyear">2022</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <div className="container">
          <div className="row mt-4">
            <div className="col-md-4">
              <div class="progess-rpeort-content agent-learning-points">
                <div class="proglefttext">Learning Points</div>
                <div class="prgcounttext">2350</div>
                <div className="d-flex gap-2 justify-content-center mt-3">
                  <div className="count-col">
                    <div className="coluns-report-rsp">
                      720
                    </div>
                    <div className="complints-sub-text">
                      This Week
                    </div>
                  </div>
                  <div className="count-col">
                    <div class="coluns-report-rsp-percent">
                      +15<small>%</small>
                    </div>
                    <div className="complints-sub-text">
                      From Last Week
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div class="progess-rpeort-content agent-learning-points">
                <div class="proglefttext">Learning Hours</div>
                <div class="prgcounttext">118.5</div>
                <div className="d-flex gap-2 justify-content-center mt-3">
                  <div className="count-col">
                    <div className="coluns-report-rsp">
                      16
                    </div>
                    <div className="complints-sub-text">
                      This Week
                    </div>
                  </div>
                  <div className="count-col">
                    <div class="coluns-report-rsp-percent minus-percent">
                      -2.5<small>%</small>
                    </div>
                    <div className="complints-sub-text">
                      From Last Week
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> 
        {/* <div id="myOnboard" class="center_line"></div> */}
        <section className="new-reports-box">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div class="progess-count-tiel">Offices&nbsp;<strong>(2)</strong></div>
              </div>
              <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
                <div class="reopor-box-progess new-report-box">
                  <div class="progess-profile d-flex">
                  
                    <div class="userprogress-details cursor-not-allowed">
                      <h5 class="user-tiele">Mahawal-2 Thornhill2</h5>
                      <p>Thornhill Office</p>
                    </div>
                  </div>
                  <hr />
                  <div class="progress-details">
                    <div class="progess-report-graph">
                      <div class="circlebox">
                        <div
                          className="circularProgress-sm"
                          style={{
                            width: 72,
                            height: 72,
                            position: "relative",
                          }}
                        >
                          <CircularProgressbar
                            value={65}
                            strokeWidth={8}
                            styles={buildStyles({
                              pathColor: "#415385", 
                              trailColor: "#EBEBEB",
                            })
                            }
                          />
                          <div className="centerprogess-con"
                            style={{
                              position: "absolute",
                              top: "1.2rem",
                              width: "72px",
                              textAlign: "center",
                            }}
                          >
                            {true ? (
                              <>
                                <strong
                                  style={{ color: "#415385" }}
                                >{`65%`}</strong>
                                <small>Progress</small>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="progess-count-show-new">
                      <div class="learning-points-new">
                        <strong>2/</strong>7
                      </div>
                      <div class="learning-points-name">
                        Agents Compliant
                      </div>
                    </div>

                  </div>
                  <div className="prog-link">
                    View More
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
                <div class="reopor-box-progess new-report-box">
                  <div class="progess-profile d-flex">
                   
                    <div class="userprogress-details cursor-not-allowed">
                      <h5 class="user-tiele">Mahawal-2 Thornhill2</h5>
                      <p>Thornhill Office</p>
                    </div>
                  </div>
                  <hr />
                  <div class="progress-details">
                    <div class="progess-report-graph">
                      <div class="circlebox">
                        <div
                          className="circularProgress-sm"
                          style={{
                            width: 72,
                            height: 72,
                            position: "relative",
                          }}
                        >
                          <CircularProgressbar
                            value={65}
                            strokeWidth={8}
                            styles={buildStyles({
                              pathColor: "#415385", 
                              trailColor: "#EBEBEB",
                            })
                            }
                          />
                          <div className="centerprogess-con"
                            style={{
                              position: "absolute",
                              top: "1.2rem",
                              width: "72px",
                              textAlign: "center",
                            }}
                          >
                            {true ? (
                              <>
                                <strong
                                  style={{ color: "#415385" }}
                                >{`65%`}</strong>
                                <small>Progress</small>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="progess-count-show-new">
                      <div class="learning-points-new">
                        <strong>2/</strong>7
                      </div>
                      <div class="learning-points-name">
                        Agents Compliant
                      </div>
                    </div>

                  </div>
                  <div className="prog-link">
                    View More
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
                <div class="reopor-box-progess new-report-box">
                  <div class="progess-profile d-flex">
                    
                    <div class="userprogress-details cursor-not-allowed">
                      <h5 class="user-tiele">Mahawal-2 Thornhill2</h5>
                      <p>Thornhill Office</p>
                    </div>
                  </div>
                  <hr />
                  <div class="progress-details">
                    <div class="progess-report-graph">
                      <div class="circlebox">
                        <div
                          className="circularProgress-sm"
                          style={{
                            width: 72,
                            height: 72,
                            position: "relative",
                          }}
                        >
                          <CircularProgressbar
                            value={65}
                            strokeWidth={8}
                            styles={buildStyles({
                              pathColor: "#415385", 
                              trailColor: "#EBEBEB",
                            })
                            }
                          />
                          <div className="centerprogess-con"
                            style={{
                              position: "absolute",
                              top: "1.2rem",
                              width: "72px",
                              textAlign: "center",
                            }}
                          >
                            {true ? (
                              <>
                                <strong
                                  style={{ color: "#415385" }}
                                >{`65%`}</strong>
                                <small>Progress</small>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="progess-count-show-new">
                      <div class="learning-points-new">
                        <strong>2/</strong>7
                      </div>
                      <div class="learning-points-name">
                        Agents Compliant
                      </div>
                    </div>

                  </div>
                  <div className="prog-link">
                    View More
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <p className="text-center">

                  <button
                    type="button"
                    id="number"
                    className="btn btn-primary-complete view-all-report"
                    onClick={() => {
                      setCount(counter, setCounter);
                      setLoadSpin(true);
                    }
                    }
                  >
                    {(loadSpin) ?
                      <div className="d-flex justify-content-center w-100">
                        <Spinner animation="border" />
                      </div>
                      : "View All"}
                  </button>


                </p>
              </div>
            </div>
          </div>
        </section>
          <section className="new-reports-box">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div class="progess-count-tiel">Managers&nbsp;<strong>(3)</strong></div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
              <div class="reopor-box-progess new-report-box">
                <div class="progess-profile d-flex">
                  <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                  <div class="userprogress-details cursor-not-allowed">
                    <h5 class="user-tiele">Anita Tiago</h5>
                    <p>Bradford</p>
                  </div>
                </div>
                <hr />
                <div class="progress-details">
                  <div class="progess-report-graph">
                    <div class="circlebox">
                      <div
                        className="circularProgress-sm"
                        style={{
                          width: 72,
                          height: 72,
                          position: "relative",
                        }}
                      >
                        <CircularProgressbar
                          value={30}
                          strokeWidth={8}
                          styles={buildStyles({
                            pathColor: "#415385", //FF9700=yellow
                            trailColor: "#EBEBEB",
                          })
                          }
                        />
                        <div className="centerprogess-con"
                          style={{
                            position: "absolute",
                            top: "1.2rem",
                            width: "72px",
                            textAlign: "center",
                          }}
                        >
                          {true ? (
                            <>
                              <strong
                                style={{ color: "#415385" }}
                              >{`30%`}</strong>
                              <small>Progress</small>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="progess-count-show-new">
                    <div class="learning-points-new">
                      <strong>4/</strong>11
                    </div>
                    <div class="learning-points-name">
                      Agents Compliant
                    </div>
                  </div>

                </div>
                <div className="prog-link">
                  View More
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
              <div class="reopor-box-progess new-report-box">
                <div class="progess-profile d-flex">
                  <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                  <div class="userprogress-details cursor-not-allowed">
                    <h5 class="user-tiele">Sophie Lee</h5>
                    <p>Richmond Hill</p>
                  </div>
                </div>
                <hr />
                <div class="progress-details">
                  <div class="progess-report-graph">
                    <div class="circlebox">
                      <div
                        className="circularProgress-sm"
                        style={{
                          width: 72,
                          height: 72,
                          position: "relative",
                        }}
                      >
                        <CircularProgressbar
                          value={27}
                          strokeWidth={8}
                          styles={buildStyles({
                            pathColor: "#415385", //FF9700=yellow
                            trailColor: "#EBEBEB",
                          })
                          }
                        />
                        <div className="centerprogess-con"
                          style={{
                            position: "absolute",
                            top: "1.2rem",
                            width: "72px",
                            textAlign: "center",
                          }}
                        >
                          {true ? (
                            <>
                              <strong
                                style={{ color: "#415385" }}
                              >{`27%`}</strong>
                              <small>Progress</small>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="progess-count-show-new">
                    <div class="learning-points-new">
                      <strong>2/</strong>7
                    </div>
                    <div class="learning-points-name">
                      Agents Compliant
                    </div>
                  </div>

                </div>
                <div className="prog-link">
                  View More
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
              <div class="reopor-box-progess new-report-box">
                <div class="progess-profile d-flex">
                  <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                  <div class="userprogress-details cursor-not-allowed">
                    <h5 class="user-tiele">Naomi S</h5>
                    <p>Bradford</p>
                  </div>
                </div>
                <hr />
                <div class="progress-details">
                  <div class="progess-report-graph">
                    <div class="circlebox">
                      <div
                        className="circularProgress-sm"
                        style={{
                          width: 72,
                          height: 72,
                          position: "relative",
                        }}
                      >
                        <CircularProgressbar
                          value={30}
                          strokeWidth={8}
                          styles={buildStyles({
                            pathColor: "#415385", //FF9700=yellow
                            trailColor: "#EBEBEB",
                          })
                          }
                        />
                        <div className="centerprogess-con"
                          style={{
                            position: "absolute",
                            top: "1.2rem",
                            width: "72px",
                            textAlign: "center",
                          }}
                        >
                          {true ? (
                            <>
                              <strong
                                style={{ color: "#415385" }}
                              >{`30%`}</strong>
                              <small>Progress</small>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="progess-count-show-new">
                    <div class="learning-points-new">
                      <strong>4/</strong>19
                    </div>
                    <div class="learning-points-name">
                      Agents Compliant
                    </div>
                  </div>

                </div>
                <div className="prog-link">
                  View More
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <p className="text-center">

                <button
                  type="button"
                  id="number"
                  className="btn btn-primary-complete view-all-report"
                  onClick={() => {
                    setCount(counter, setCounter);
                    setLoadSpin(true);
                  }
                  }
                >
                  {(loadSpin) ?
                    <div className="d-flex justify-content-center w-100">
                      <Spinner animation="border" />
                    </div>
                    : "View All"}
                </button>


              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="new-reports-box pb-5 las-sec-cards-report">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div class="progess-count-tiel">Agents&nbsp;<strong>(11)</strong></div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
              <div class="reopor-box-progess new-report-box">
                <div class="progess-profile d-flex">
                  <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                  <div class="userprogress-details cursor-not-allowed">
                    <h5 class="user-tiele">John Digweed</h5>
                    <p>Bradford</p>
                  </div>
                </div>
                <hr />
                <div class="progress-details">
                  <div class="progess-report-graph">
                    <div class="circlebox">
                      <div
                        className="circularProgress-sm"
                        style={{
                          width: 72,
                          height: 72,
                          position: "relative",
                        }}
                      >
                        <CircularProgressbar
                          value={0}
                          strokeWidth={8}
                          styles={buildStyles({
                            pathColor: "#415385", //FF9700=yellow
                            trailColor: "#EBEBEB",
                          })
                          }
                        />
                        <div className="centerprogess-con"
                          style={{
                            position: "absolute",
                            top: "1.2rem",
                            width: "72px",
                            textAlign: "center",
                          }}
                        >
                          {true ? (
                            <>
                              {/* <strong
                                style={{ color: "#415385" }}
                              >{`65%`}</strong> */}
                              <small>Yet to<br/> start</small>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="progess-count-show-new">
                    <div class="learning-points-new">
                      <strong>0/</strong>7
                    </div>
                    <div class="learning-points-name">
                      Agents Compliant
                    </div>
                  </div>

                </div>
                <div className="prog-link">
                  View More
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
              <div class="reopor-box-progess new-report-box">
                <div class="progess-profile d-flex">
                  <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                  <div class="userprogress-details cursor-not-allowed">
                    <h5 class="user-tiele">Tress Rhodes</h5>
                    <p>Richmond Hill</p>
                  </div>
                </div>
                <hr />
                <div class="progress-details">
                  <div class="progess-report-graph">
                    <div class="circlebox">
                      <div
                        className="circularProgress-sm"
                        style={{
                          width: 72,
                          height: 72,
                          position: "relative",
                        }}
                      >
                        <CircularProgressbar
                          value={26}
                          strokeWidth={8}
                          styles={buildStyles({
                            pathColor: "#415385", //FF9700=yellow
                            trailColor: "#EBEBEB",
                          })
                          }
                        />
                        <div className="centerprogess-con"
                          style={{
                            position: "absolute",
                            top: "1.2rem",
                            width: "72px",
                            textAlign: "center",
                          }}
                        >
                          {true ? (
                            <>
                              <strong
                                style={{ color: "#415385" }}
                              >{`26%`}</strong>
                              <small>Progress</small>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="progess-count-show-new">
                    <div class="learning-points-new">
                      <strong>2/</strong>7
                    </div>
                    <div class="learning-points-name">
                      Agents Compliant
                    </div>
                  </div>

                </div>
                <div className="prog-link">
                  View More
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
              <div class="reopor-box-progess new-report-box">
                <div class="progess-profile d-flex">
                  <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                  <div class="userprogress-details cursor-not-allowed">
                    <h5 class="user-tiele">Amy Lane</h5>
                    <p>Bradford</p>
                  </div>
                </div>
                <hr />
                <div class="progress-details">
                  <div class="progess-report-graph">
                    <div class="circlebox">
                      <div
                        className="circularProgress-sm"
                        style={{
                          width: 72,
                          height: 72,
                          position: "relative",
                        }}
                      >
                        <CircularProgressbar
                          value={30}
                          strokeWidth={8}
                          styles={buildStyles({
                            pathColor: "#415385", //FF9700=yellow
                            trailColor: "#EBEBEB",
                          })
                          }
                        />
                        <div className="centerprogess-con"
                          style={{
                            position: "absolute",
                            top: "1.2rem",
                            width: "72px",
                            textAlign: "center",
                          }}
                        >
                          {true ? (
                            <>
                              <strong
                                style={{ color: "#415385" }}
                              >{`30%`}</strong>
                              <small>Progress</small>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="progess-count-show-new">
                    <div class="learning-points-new">
                      <strong>3/</strong>7
                    </div>
                    <div class="learning-points-name">
                      Agents Compliant
                    </div>
                  </div>

                </div>
                <div className="prog-link">
                  View More
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
              <div class="reopor-box-progess new-report-box">
                <div class="progess-profile d-flex">
                  <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                  <div class="userprogress-details cursor-not-allowed">
                    <h5 class="user-tiele">Richard Rams</h5>
                    <p>Bradford</p>
                  </div>
                </div>
                <hr />
                <div class="progress-details">
                  <div class="progess-report-graph">
                    <div class="circlebox">
                      <div
                        className="circularProgress-sm"
                        style={{
                          width: 72,
                          height: 72,
                          position: "relative",
                        }}
                      >
                        <CircularProgressbar
                          value={12}
                          strokeWidth={8}
                          styles={buildStyles({
                            pathColor: "#415385", //FF9700=yellow
                            trailColor: "#EBEBEB",
                          })
                          }
                        />
                        <div className="centerprogess-con"
                          style={{
                            position: "absolute",
                            top: "1.2rem",
                            width: "72px",
                            textAlign: "center",
                          }}
                        >
                          {true ? (
                            <>
                              <strong
                                style={{ color: "#415385" }}
                              >{`12%`}</strong>
                              <small>Progress</small>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="progess-count-show-new">
                    <div class="learning-points-new">
                      <strong>1/</strong>7
                    </div>
                    <div class="learning-points-name">
                      Agents Compliant
                    </div>
                  </div>

                </div>
                <div className="prog-link">
                  View More
                </div>
              </div>
            </div>
            <div className="col-md-12 mt-3">
              <p className="text-center">

                <button
                  type="button"
                  id="number"
                  className="btn btn-primary-complete view-all-report"
                  onClick={() => {
                    setCount(counter, setCounter);
                    setLoadSpin(true);
                  }
                  }
                >
                  {(loadSpin) ?
                    <div className="d-flex justify-content-center w-100">
                      <Spinner animation="border" />
                    </div>
                    : "View All"}
                </button>


              </p>
            </div>
          </div>
        </div>
      </section>
        {/* <section className="new-reports-box">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div class="progess-count-tiel">Managers&nbsp;<strong>(2)</strong></div>
              </div>
              <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
                <div class="reopor-box-progess new-report-box">
                  <div class="progess-profile d-flex">
                    <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                    <div class="userprogress-details cursor-not-allowed">
                      <h5 class="user-tiele">Mahawal-2 Thornhill2</h5>
                      <p>Thornhill Office</p>
                    </div>
                  </div>
                  <hr />
                  <div class="progress-details">
                    <div class="progess-report-graph">
                      <div class="circlebox">
                        <div
                          className="circularProgress-sm"
                          style={{
                            width: 72,
                            height: 72,
                            position: "relative",
                          }}
                        >
                          <CircularProgressbar
                            value={65}
                            strokeWidth={8}
                            styles={buildStyles({
                              pathColor: "#415385", //FF9700=yellow
                              trailColor: "#EBEBEB",
                            })
                            }
                          />
                          <div className="centerprogess-con"
                            style={{
                              position: "absolute",
                              top: "1.2rem",
                              width: "72px",
                              textAlign: "center",
                            }}
                          >
                            {true ? (
                              <>
                                <strong
                                  style={{ color: "#415385" }}
                                >{`65%`}</strong>
                                <small>Progress</small>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="progess-count-show-new">
                      <div class="learning-points-new">
                        <strong>2/</strong>7
                      </div>
                      <div class="learning-points-name">
                        Agents Compliant
                      </div>
                    </div>

                  </div>
                  <div className="prog-link">
                    View More
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
                <div class="reopor-box-progess new-report-box">
                  <div class="progess-profile d-flex">
                    <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                    <div class="userprogress-details cursor-not-allowed">
                      <h5 class="user-tiele">Mahawal-2 Thornhill2</h5>
                      <p>Thornhill Office</p>
                    </div>
                  </div>
                  <hr />
                  <div class="progress-details">
                    <div class="progess-report-graph">
                      <div class="circlebox">
                        <div
                          className="circularProgress-sm"
                          style={{
                            width: 72,
                            height: 72,
                            position: "relative",
                          }}
                        >
                          <CircularProgressbar
                            value={65}
                            strokeWidth={8}
                            styles={buildStyles({
                              pathColor: "#415385", //FF9700=yellow
                              trailColor: "#EBEBEB",
                            })
                            }
                          />
                          <div className="centerprogess-con"
                            style={{
                              position: "absolute",
                              top: "1.2rem",
                              width: "72px",
                              textAlign: "center",
                            }}
                          >
                            {true ? (
                              <>
                                <strong
                                  style={{ color: "#415385" }}
                                >{`65%`}</strong>
                                <small>Progress</small>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="progess-count-show-new">
                      <div class="learning-points-new">
                        <strong>2/</strong>7
                      </div>
                      <div class="learning-points-name">
                        Agents Compliant
                      </div>
                    </div>

                  </div>
                  <div className="prog-link">
                    View More
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
                <div class="reopor-box-progess new-report-box">
                  <div class="progess-profile d-flex">
                    <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                    <div class="userprogress-details cursor-not-allowed">
                      <h5 class="user-tiele">Mahawal-2 Thornhill2</h5>
                      <p>Thornhill Office</p>
                    </div>
                  </div>
                  <hr />
                  <div class="progress-details">
                    <div class="progess-report-graph">
                      <div class="circlebox">
                        <div
                          className="circularProgress-sm"
                          style={{
                            width: 72,
                            height: 72,
                            position: "relative",
                          }}
                        >
                          <CircularProgressbar
                            value={65}
                            strokeWidth={8}
                            styles={buildStyles({
                              pathColor: "#415385", //FF9700=yellow
                              trailColor: "#EBEBEB",
                            })
                            }
                          />
                          <div className="centerprogess-con"
                            style={{
                              position: "absolute",
                              top: "1.2rem",
                              width: "72px",
                              textAlign: "center",
                            }}
                          >
                            {true ? (
                              <>
                                <strong
                                  style={{ color: "#415385" }}
                                >{`65%`}</strong>
                                <small>Progress</small>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="progess-count-show-new">
                      <div class="learning-points-new">
                        <strong>2/</strong>7
                      </div>
                      <div class="learning-points-name">
                        Agents Compliant
                      </div>
                    </div>

                  </div>
                  <div className="prog-link">
                    View More
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <p className="text-center">

                  <button
                    type="button"
                    id="number"
                    className="btn btn-primary-complete view-all-report"
                    onClick={() => {
                      setCount(counter, setCounter);
                      setLoadSpin(true);
                    }
                    }
                  >
                    {(loadSpin) ?
                      <div className="d-flex justify-content-center w-100">
                        <Spinner animation="border" />
                      </div>
                      : "View All"}
                  </button>


                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="new-reports-box pb-5 las-sec-cards-report">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div class="progess-count-tiel">Agents&nbsp;<strong>(2)</strong></div>
              </div>
              <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
                <div class="reopor-box-progess new-report-box">
                  <div class="progess-profile d-flex">
                    <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                    <div class="userprogress-details cursor-not-allowed">
                      <h5 class="user-tiele">Mahawal-2 Thornhill2</h5>
                      <p>Thornhill Office</p>
                    </div>
                  </div>
                  <hr />
                  <div class="progress-details">
                    <div class="progess-report-graph">
                      <div class="circlebox">
                        <div
                          className="circularProgress-sm"
                          style={{
                            width: 72,
                            height: 72,
                            position: "relative",
                          }}
                        >
                          <CircularProgressbar
                            value={65}
                            strokeWidth={8}
                            styles={buildStyles({
                              pathColor: "#415385", //FF9700=yellow
                              trailColor: "#EBEBEB",
                            })
                            }
                          />
                          <div className="centerprogess-con"
                            style={{
                              position: "absolute",
                              top: "1.2rem",
                              width: "72px",
                              textAlign: "center",
                            }}
                          >
                            {true ? (
                              <>
                                <strong
                                  style={{ color: "#415385" }}
                                >{`65%`}</strong>
                                <small>Progress</small>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="progess-count-show-new">
                      <div class="learning-points-new">
                        <strong>2/</strong>7
                      </div>
                      <div class="learning-points-name">
                        Agents Compliant
                      </div>
                    </div>

                  </div>
                  <div className="prog-link">
                    View More
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
                <div class="reopor-box-progess new-report-box">
                  <div class="progess-profile d-flex">
                    <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                    <div class="userprogress-details cursor-not-allowed">
                      <h5 class="user-tiele">Mahawal-2 Thornhill2</h5>
                      <p>Thornhill Office</p>
                    </div>
                  </div>
                  <hr />
                  <div class="progress-details">
                    <div class="progess-report-graph">
                      <div class="circlebox">
                        <div
                          className="circularProgress-sm"
                          style={{
                            width: 72,
                            height: 72,
                            position: "relative",
                          }}
                        >
                          <CircularProgressbar
                            value={65}
                            strokeWidth={8}
                            styles={buildStyles({
                              pathColor: "#415385", //FF9700=yellow
                              trailColor: "#EBEBEB",
                            })
                            }
                          />
                          <div className="centerprogess-con"
                            style={{
                              position: "absolute",
                              top: "1.2rem",
                              width: "72px",
                              textAlign: "center",
                            }}
                          >
                            {true ? (
                              <>
                                <strong
                                  style={{ color: "#415385" }}
                                >{`65%`}</strong>
                                <small>Progress</small>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="progess-count-show-new">
                      <div class="learning-points-new">
                        <strong>2/</strong>7
                      </div>
                      <div class="learning-points-name">
                        Agents Compliant
                      </div>
                    </div>

                  </div>
                  <div className="prog-link">
                    View More
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 col-xl-3 col-12 mb-report">
                <div class="reopor-box-progess new-report-box">
                  <div class="progess-profile d-flex">
                    <div class="user-progess-img"><img src="https://secure.gravatar.com/avatar/f8368faf8d4f86852e649c81975384d4?s=96&amp;d=mm&amp;r=g" width="48" height="48" /></div>
                    <div class="userprogress-details cursor-not-allowed">
                      <h5 class="user-tiele">Mahawal-2 Thornhill2</h5>
                      <p>Thornhill Office</p>
                    </div>
                  </div>
                  <hr />
                  <div class="progress-details">
                    <div class="progess-report-graph">
                      <div class="circlebox">
                        <div
                          className="circularProgress-sm"
                          style={{
                            width: 72,
                            height: 72,
                            position: "relative",
                          }}
                        >
                          <CircularProgressbar
                            value={65}
                            strokeWidth={8}
                            styles={buildStyles({
                              pathColor: "#415385", //FF9700=yellow
                              trailColor: "#EBEBEB",
                            })
                            }
                          />
                          <div className="centerprogess-con"
                            style={{
                              position: "absolute",
                              top: "1.2rem",
                              width: "72px",
                              textAlign: "center",
                            }}
                          >
                            {true ? (
                              <>
                                <strong
                                  style={{ color: "#415385" }}
                                >{`65%`}</strong>
                                <small>Progress</small>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="progess-count-show-new">
                      <div class="learning-points-new">
                        <strong>2/</strong>7
                      </div>
                      <div class="learning-points-name">
                        Agents Compliant
                      </div>
                    </div>

                  </div>
                  <div className="prog-link">
                    View More
                  </div>
                </div>
              </div>
              <div className="col-md-12 mt-3">
                <p className="text-center">

                  <button
                    type="button"
                    id="number"
                    className="btn btn-primary-complete view-all-report"
                    onClick={() => {
                      setCount(counter, setCounter);
                      setLoadSpin(true);
                    }
                    }
                  >
                    {(loadSpin) ?
                      <div className="d-flex justify-content-center w-100">
                        <Spinner animation="border" />
                      </div>
                      : "View All"}
                  </button>


                </p>
              </div>
            </div>
          </div>
        </section> */}
        <section className="table-rsp-report-sec">
        <div class="center_line mb-4 table-sep report-btn-sep"></div>
        <div className="container">
          <div className="row list-coach report-table-rsp-new">
            <div className="col-lg-12 col-md-12">
              <div className="table-head">
                Details
              </div>
            </div>
            <div className="search-table-report">
              <div className="profile-left-sec">
                <div className="input-text position-relative d-flex">
                  <label htmlFor="search" className="input__label">Search</label>
                  <input type="text" id="search" name="search"
                    className="input_field mr-2" placeholder=" "
                    value=""

                  />
                  <button className="button-reset" style={{ marginTop: "-20px" }} >
                    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Find" width="30" height="30" viewBox="0 0 30 30">
                      <defs>
                        <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                          <stop offset="0" stop-color="#415385" />
                          <stop offset="1" stop-color="#415385" />
                        </linearGradient>
                      </defs>
                      <circle id="Ellipse_191" data-name="Ellipse 191" cx="15" cy="15" r="15" fill="url(#linear-gradient)" />
                      <circle id="Ellipse_192" data-name="Ellipse 192" cx="13" cy="13" r="13" transform="translate(2 2)" fill="#fff" />
                      <path id="Icon_awesome-search" data-name="Icon awesome-search" d="M14.372,12.6,11.535,9.762a.683.683,0,0,0-.484-.2h-.464a5.917,5.917,0,1,0-1.025,1.025v.464a.683.683,0,0,0,.2.484L12.6,14.372a.68.68,0,0,0,.965,0l.805-.805A.686.686,0,0,0,14.372,12.6ZM5.92,9.562A3.643,3.643,0,1,1,9.562,5.92,3.641,3.641,0,0,1,5.92,9.562Z" transform="translate(7.715 7.714)" fill="#415385" />
                    </svg>
                  </button>
                </div>

              </div>
            </div>
            <div className="col-lg-12 col-md-12">
              <div className="table-responsive1">
                <div className="tablebox">
                  <table className="table mb-0 office_list table-striped">
                    <thead>
                      <tr>
                        <th className="office-province">Name</th>
                        <th className="office-province">Reports to</th>
                        <th className="office-province">Location</th>
                        <th className="office-province">Status</th>
                        <th className="office-province text-center">Progress %</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr className="addBGcustomw">
                        <td>John Digweed</td>
                        <td>Ryan Compden</td>
                        <td>Bradford</td>
                        <td className="overdue-sta status-rp">Overdue</td>
                        <td className="text-center">0%</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td>Tress Rhodes</td>
                        <td>Josh Butler</td>
                        <td>Richmond Hill</td>
                        <td className="overdue-sta status-rp">Overdue</td>
                        <td className="text-center">0%</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td>Amy Lane</td>
                        <td>Ryan Compden</td>
                        <td>Bradford</td>
                        <td className="overdue-sta status-rp">Overdue</td>
                        <td className="text-center">20%</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td>Richard Rams</td>
                        <td>Ryan Compden</td>
                        <td>Bradford</td>
                        <td className="overdue-sta status-rp">Overdue</td>
                        <td className="text-center">36%</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td>Avijit Sinha</td>
                        <td>Anita Tiago</td>
                        <td>Bradford</td>
                        <td className="overdue-sta status-rp">Overdue</td>
                        <td className="text-center">36%</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td>Mark Wilson</td>
                        <td>Kyle Wu</td>
                        <td>Tottenham</td>
                        <td className="overdue-sta status-rp">Overdue</td>
                        <td className="text-center">44%</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td>Dorothy M</td>
                        <td>Ryan Compden</td>
                        <td>Richmond Hill</td>
                        <td className="inprogress-sta status-rp">In Progress</td>
                        <td className="text-center">70%</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td>Nathaniel Jonas</td>
                        <td>Kyle Wu</td>
                        <td>Tottenham</td>
                        <td className="inprogress-sta status-rp">In Progress</td>
                        <td className="text-center">86%</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td>Silvia Rattich</td>
                        <td>Anita Tiago</td>
                        <td>Bradford</td>
                        <td className="inprogress-sta status-rp">In Progress</td>
                        <td className="text-center">92%</td>
                      </tr>
                      <tr className="addBGcustomw">
                        <td>Rishabh Jain</td>
                        <td>Anita Tiago</td>
                        <td>Bradford</td>
                        <td className="inprogress-sta status-rp">In Progress</td>
                        <td className="text-center">92%</td>
                      </tr>
                      
                      <tr className="addBGcustomw">
                        <td>Pete Tong</td>
                        <td>Josh Butler</td>
                        <td>Richmond Hill</td>
                        <td className="completed-sta status-rp">Completed</td>
                        <td className="text-center">100%</td>
                      </tr>
                      
                    </tbody>
                  </table>
                </div>
                <div className="pagnation-table">
                  <ul className="pagination-container">
                    <li className="pagination-itemarrow-left" >
                      <div className="arrowleft">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Next" width="30"
                          height="30" viewBox="0 0 30 30">
                          <defs>
                            <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                              <stop offset="0" stop-color="#415385"></stop><stop offset="1" stop-color="#415385"></stop>
                            </linearGradient></defs><circle id="Ellipse_57" data-name="Ellipse 57" cx="15" cy="15" r="15" fill="url(#linear-gradient)"></circle><circle id="Ellipse_179" data-name="Ellipse 179" cx="13" cy="13" r="13" transform="translate(2 2)" fill="#fff"></circle><g id="Group_1344" data-name="Group 1344" transform="translate(22 15.002) rotate(135)"><path id="Path_415" data-name="Path 415" d="M0,0H8V8" transform="translate(8.001 0) rotate(90)" fill="none" stroke="#415385" stroke-linecap="round" stroke-linejoin="round" strokeWidth="4"></path></g></svg>
                      </div>
                    </li>
                    <li className="pagination-item dots active"></li>
                    <li className="pagination-item dots"></li>
                    <li className="pagination-itemarrow">
                      <div className="arrowright">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Next" width="30"
                          height="30" viewBox="0 0 30 30">
                          <defs>
                            <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                              <stop offset="0" stopColor="#415385"></stop>
                              <stop offset="1" stopColor="#415385"></stop>
                            </linearGradient>
                          </defs>
                          <circle id="Ellipse_57" data-name="Ellipse 57" cx="15" cy="15" r="15" fill="url(#linear-gradient)">
                          </circle>
                          <circle id="Ellipse_179" data-name="Ellipse 179" cx="13" cy="13" r="13" transform="translate(2 2)"
                            fill="#fff"></circle>
                          <g id="Group_1344" data-name="Group 1344" transform="translate(43.406 -779.787) rotate(45)">
                            <path id="Path_415" data-name="Path 415" d="M0,8H8V0" transform="translate(536.5 587.5) rotate(-90)"
                              fill="none" stroke="#415385" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4">
                            </path>
                          </g>
                        </svg>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="table-repost-de">
                  Showing 1-11 of 42
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
        {/* <section className="table-rsp-report-sec">
          <div class="center_line mb-4 table-sep report-btn-sep"></div>
          <div className="container">
            <div className="row list-coach report-table-rsp-new">
              <div className="col-lg-12 col-md-12">
                <div className="table-head">
                  Details
                </div>
              </div>
              <div className="search-table-report">
                <div className="profile-left-sec">
                  <div className="input-text position-relative d-flex">
                    <label htmlFor="search" className="input__label">Search</label>
                    <input type="text" id="search" name="search"
                      className="input_field mr-2" placeholder=" "
                      value=""

                    />
                    <button className="button-reset" style={{ marginTop: "-20px" }} >
                      <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Find" width="30" height="30" viewBox="0 0 30 30">
                        <defs>
                          <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                            <stop offset="0" stop-color="#415385" />
                            <stop offset="1" stop-color="#415385" />
                          </linearGradient>
                        </defs>
                        <circle id="Ellipse_191" data-name="Ellipse 191" cx="15" cy="15" r="15" fill="url(#linear-gradient)" />
                        <circle id="Ellipse_192" data-name="Ellipse 192" cx="13" cy="13" r="13" transform="translate(2 2)" fill="#fff" />
                        <path id="Icon_awesome-search" data-name="Icon awesome-search" d="M14.372,12.6,11.535,9.762a.683.683,0,0,0-.484-.2h-.464a5.917,5.917,0,1,0-1.025,1.025v.464a.683.683,0,0,0,.2.484L12.6,14.372a.68.68,0,0,0,.965,0l.805-.805A.686.686,0,0,0,14.372,12.6ZM5.92,9.562A3.643,3.643,0,1,1,9.562,5.92,3.641,3.641,0,0,1,5.92,9.562Z" transform="translate(7.715 7.714)" fill="#415385" />
                      </svg>
                    </button>
                  </div>

                </div>
              </div>
              <div className="col-lg-12 col-md-12">
                <div className="table-responsive1">
                  <div className="tablebox">
                    <table className="table mb-0 office_list table-striped">
                      <thead>
                        <tr>
                          <th className="office-province">Name</th>
                          <th className="office-province">Started</th>
                          <th className="office-province">Status</th>
                          <th className="office-province text-center">Progress %</th>
                          <th className="office-province">Completed</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="addBGcustomw">
                          <td>Code of Ethics</td>
                          <td><strong>23-08-2022</strong></td>
                          <td>
                            <span class="complte">
                              <img src="/images/check-report.svg" width="18" height="18" />
                            </span>
                            <strong>Completed</strong>
                          </td>
                          <td className="text-center"><strong>100%</strong></td>
                          <td><strong>23-08-2022</strong></td>
                        </tr>
                        <tr className="addBGcustomw">
                          <td>Sales Training</td>
                          <td><strong>23-08-2022</strong></td>
                          <td>
                            <span class="complte">
                              <img src="/images/yet-to-start-svg.svg" width="18" height="18" />
                            </span>
                            <strong>Yet to start</strong>
                          </td>
                          <td className="text-center"><strong>8%</strong></td>
                          <td><strong>23-08-2022</strong></td>
                        </tr>
                        <tr className="addBGcustomw">
                          <td>Sales Training</td>
                          <td><strong>23-08-2022</strong></td>
                          <td>
                            <span class="complte">
                              <img src="/images/inprogress.svg" width="18" height="18" />
                            </span>
                            <strong>In progress</strong>
                          </td>
                          <td className="text-center"><strong>18%</strong></td>
                          <td><strong>--</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="pagnation-table">
                    <ul className="pagination-container">
                      <li className="pagination-itemarrow-left" >
                        <div className="arrowleft">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Next" width="30"
                            height="30" viewBox="0 0 30 30">
                            <defs>
                              <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                <stop offset="0" stop-color="#415385"></stop><stop offset="1" stop-color="#415385"></stop>
                              </linearGradient></defs><circle id="Ellipse_57" data-name="Ellipse 57" cx="15" cy="15" r="15" fill="url(#linear-gradient)"></circle><circle id="Ellipse_179" data-name="Ellipse 179" cx="13" cy="13" r="13" transform="translate(2 2)" fill="#fff"></circle><g id="Group_1344" data-name="Group 1344" transform="translate(22 15.002) rotate(135)"><path id="Path_415" data-name="Path 415" d="M0,0H8V8" transform="translate(8.001 0) rotate(90)" fill="none" stroke="#415385" stroke-linecap="round" stroke-linejoin="round" strokeWidth="4"></path></g></svg>
                        </div>
                      </li>
                      <li className="pagination-item dots active"></li>
                      <li className="pagination-item dots"></li>
                      <li className="pagination-itemarrow">
                        <div className="arrowright">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Next" width="30"
                            height="30" viewBox="0 0 30 30">
                            <defs>
                              <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
                                <stop offset="0" stopColor="#415385"></stop>
                                <stop offset="1" stopColor="#415385"></stop>
                              </linearGradient>
                            </defs>
                            <circle id="Ellipse_57" data-name="Ellipse 57" cx="15" cy="15" r="15" fill="url(#linear-gradient)">
                            </circle>
                            <circle id="Ellipse_179" data-name="Ellipse 179" cx="13" cy="13" r="13" transform="translate(2 2)"
                              fill="#fff"></circle>
                            <g id="Group_1344" data-name="Group 1344" transform="translate(43.406 -779.787) rotate(45)">
                              <path id="Path_415" data-name="Path 415" d="M0,8H8V0" transform="translate(536.5 587.5) rotate(-90)"
                                fill="none" stroke="#415385" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4">
                              </path>
                            </g>
                          </svg>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="table-repost-de">
                    Showing 1-4 of 16
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </section>

      <div>



      </div>
    </>

  );
};

export default AgentReportSection;
